// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"bfe3a2d2","767":"df09ac7a"}[chunkId] + ".chunk.js";
};